import { h, Fragment, Component, createRef } from 'preact'
import cn from 'classnames'
import { Loader } from '../Loader'
import Bubble from '../Bubble'
import s from './Button.css'

interface iProps {
  className?: string
  disabled?: boolean
  onClick?: (e: MouseEvent) => void
  isLoading?: boolean
}

export class Button extends Component<iProps> {
  render () {
    const {
      className,
      disabled,
      isLoading,
      children,
      ...restProps
    } = this.props

    const isDisabled = disabled || isLoading

    return (
      <button
        className={cn(s.Button, className)}
        disabled={isDisabled}
        {...restProps}
      >
        {isLoading && (
          <Fragment>
            Please wait
            <span className={s.Button__loader}>
              <Loader/>
            </span>
          </Fragment>
        )}

        {!isDisabled && (
          <Bubble color="blue">
            {children}
          </Bubble>
        )}
      </button>
    )
  }
}
